// extracted by mini-css-extract-plugin
export default {"mCard":"zD-z","image":"AD-z","imageNoBackground":"BD-z","imageHasCategory":"CD-z","fullWidth":"DD-z"};